var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GoodsListView',{attrs:{"line-num":2,"line-items":5,"title":"全部商品"}})}
var staticRenderFns = []

export { render, staticRenderFns }